export default "__VITE_ASSET__DyVTeD$4__"